<template>
  <div>
    <v-row class="pt-6 align-item-s" v-if="certificates && certificates.length">
      <v-col xs="12" sm="12" lg="6" v-for="(item, index) in certificates" :key="'row_' + index">
        <CertificateItem :certificate="item" @edit="edit(item)" @remove="remove(item)" :skills="skills" />
      </v-col>
    </v-row>
    <v-row v-else class="pt-16 pb-16 mt-16">
      <v-col class="text-center">
        <h2>You can see added certificates here</h2>
      </v-col>
    </v-row>
  </div>
</template>
<script lang="ts">
import { Certificate } from "../../../models/Teammember";
import Utils from "../../../utils/Utils";
import { defineComponent } from "vue";
import CertificateItem from "./CertificateItem.vue";

export default defineComponent({
  props: ["skills", "certificateList", "addLoading", "isHiringmanager"],
  components: { CertificateItem },
  data() {
    return {
      certificates: [] as Certificate[],
      loading: false,
    };
  },
  methods: {
    getSkillName(skillId: any) {
      var findSkill = this.skills.find((s: any) => s.id === skillId);
      if (findSkill) {
        return findSkill.Text;
      }
    },
    edit(item: any) {
      this.$emit("edit", item);
    },
    remove(item: any) {
      this.$emit("remove", item);
    },
    formatDate(value: any): string {
      return `${Utils.toVsDateFormat(value)}`;
    },
  },
  watch: {
    addLoading(newVal) {
      this.loading = newVal;
    },
    certificateList(newVal) {
      this.certificates = newVal;
    },
  },

  mounted() {
    this.certificates = [...this.certificateList];
  },
});
</script>
